import * as actions from './actions';

export type State = {
  tempScenario: Record<string, any>;
  modelledScenario?: Record<string, any>;
  updatedFields: Record<string, any>;
};

export default (
  state: State = {
    tempScenario: {},
    modelledScenario: {},
    updatedFields: {},
  },
  action: any,
): State => {
  switch (action.type) {
    case actions.SET_INITIAL_STATE_FOR_RETIREMENT_INCOME_GOAL:
      return {
        ...state,
        tempScenario: {
          ...action.payload,
        },
        modelledScenario: {
          ...action.payload,
        },
        updatedFields: {},
      };
    case actions.UPDATE_RETIREMENT_INCOME_GOAL_DATA:
      return {
        ...state,
        tempScenario: {
          ...state.tempScenario,
          ...action.payload,
        },
        updatedFields: {
          ...state.updatedFields,
          ...action.payload,
        },
      };
    case actions.MODEL_RETIREMENT_INCOME_GOAL_SCENARIO:
      return {
        ...state,
        modelledScenario: state.tempScenario,
      };

    default:
      return state;
  }
};
